import Vue from "vue";
import { normalizeIdFormAnswer } from "@/libs/actionPlanRunCommandResponse";
import { payloadContainsResponseOperationalForm } from "@/libs/responseOperationalForm";

function parseCreatedAtTimestamp(iso) {
  if (iso == null || iso === "") {
    return 0;
  }
  const parsed = Date.parse(String(iso));
  return Number.isNaN(parsed) ? 0 : parsed;
}

function normalizeCmdId(raw) {
  if (raw == null || raw === "") {
    return null;
  }
  const n = Number(raw);
  return Number.isNaN(n) ? null : n;
}

function operationalFormAnswerResultToFields(result) {
  if (!result || typeof result !== "object") {
    return null;
  }
  const id_form_answer = normalizeIdFormAnswer(result.id_form_answer);
  if (id_form_answer == null) {
    return null;
  }
  const reference =
    result.reference != null && String(result.reference).trim() !== ""
      ? String(result.reference)
      : "";
  const out = {
    id_form_answer,
    reference,
  };
  if (result.id_template != null) {
    out.id_template = result.id_template;
  }
  return out;
}

function isMatchingResponseFormNode(action, resultCmdId) {
  if (!action || action.type !== "Node") {
    return false;
  }
  if (!payloadContainsResponseOperationalForm(action.node_data)) {
    return false;
  }
  const nodeCmdId = normalizeCmdId(action.node_data?.cmd_id);
  if (nodeCmdId == null || resultCmdId == null) {
    return false;
  }
  return nodeCmdId === resultCmdId;
}

function applyFieldsToActionData(action, fields) {
  if (!action.data || typeof action.data !== "object") {
    Vue.set(action, "data", {});
  }
  Vue.set(action.data, "executed", true);
  Vue.set(action.data, "status", "OK");
  Vue.set(action.data, "responseFormLogStatus", "ready");
  Vue.set(action.data, "responseFormAnswerId", fields.id_form_answer);
  Vue.set(
    action.data,
    "responseFormReference",
    fields.reference != null ? fields.reference : ""
  );
  if (fields.id_template != null) {
    Vue.set(action.data, "responseFormTemplateId", fields.id_template);
  }
}

export function mergeOperationalFormAnswerResultsIntoLog(log) {
  if (!log || typeof log !== "object") {
    return;
  }
  const history = log.history;
  const results = log.operational_form_answer_results;
  if (!Array.isArray(history) || !Array.isArray(results) || results.length === 0) {
    return;
  }

  const sorted = [...results].sort(
    (a, b) =>
      parseCreatedAtTimestamp(a?.created_at) -
      parseCreatedAtTimestamp(b?.created_at)
  );

  const patchedNodeIds = new Set();

  sorted.forEach((result) => {
    const fields = operationalFormAnswerResultToFields(result);
    if (!fields) {
      return;
    }
    const resultCmdId = normalizeCmdId(result.cmd_id);
    if (resultCmdId == null) {
      return;
    }

    const action = history.find((item) => {
      if (!item || patchedNodeIds.has(String(item.id))) {
        return false;
      }
      if (!isMatchingResponseFormNode(item, resultCmdId)) {
        return false;
      }
      return true;
    });

    if (!action) {
      return;
    }

    const nodeKey = String(action.id);
    const existingId = normalizeIdFormAnswer(action.data?.responseFormAnswerId);
    const targetId = fields.id_form_answer;
    if (existingId != null && existingId === targetId) {
      patchedNodeIds.add(nodeKey);
      return;
    }

    applyFieldsToActionData(action, fields);
    patchedNodeIds.add(nodeKey);
  });
}
